import { Button, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import { FaInfoCircle } from "react-icons/fa";
import { FaUserPlus } from "react-icons/fa6";
import INtroduction from "./INtroduction";
import FrameSection1 from "./FrameSection1";
import FrameSection2 from "./FrameSection2";
import backImg from "./backgroundImg.png";
import FrameSection1B from "./FrameSection1B";
import IntroductionFrame from "./IntroductionFrame";
import Img3 from "./svgImage/badge2.png";
import backgroundImg from "./svgImage/heroImgBackground.png";
import CardInformation from "./CardInformation";
import BottomSection1 from "./BottomSection1";
import FrameSection1C from "./FrameSection1C";
import backImg1 from "./svgImage/backgroundIMg121.webp";
import backImg11 from "./svgImage/heroSectionImg/b11.jpg";
import backImg12 from "./svgImage/heroSectionImg/b22.jpg";
import backImg13 from "./svgImage/heroSectionImg/b33.jpg";
import backImg15 from "./svgImage/heroSectionImg/bg289.jpg";
import backImg14 from "./svgImage/heroImgBackgroundPattern.png";
import CardInformationB from "./CardInformationB";
import CardInformationB2 from "./CardInformationB2";

const Testing1 = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [pmData, setPmData] = useState(0);

  const bgUrl = [
    './heroBg/morning.svg',
    './heroBg/afternoon.svg',
    './heroBg/night.svg',
  ];

  // const color1 = "#054E91"; // Deep Blue
  // const color2 = "#1F85C0"; // Medium Blue
  // const color3 = "#97cff0ff"; // Light Blue

  // const gradientBackground = `linear-gradient(to right, ${color1}, ${color2}, ${color3})`;

  return (
    <Stack
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundSize: "cover",
        backgroundPosition: "center",
        // backgroundColor: "#ebf4ff",
        backgroundImage: `url(${bgUrl[pmData]})`,
        paddingTop: { xl: "40px", lg: "20px", md: "40px", sm: "40px" },
        // border: "4px solid red",
      }}
    >
      <Stack
        sx={{
          width: { xl: "74%", lg: "79%", md: "90%", sm: "90%" },
          // border: "2px solid red",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          //   alignItems: "center",
          marginBottom: { xl: "64px", lg: "40px", md: "40px", sm: "60px" },
        }}
      >
        {" "}
        <CardInformationB2
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          setPmData={setPmData} // <-- Added this
          pmData={pmData}
        />
      </Stack>

      <Stack
        sx={{
          width: { xl: "92%", lg: "92%", md: "100%", sm: "100%" },
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          // border: "3px solid red",
        }}
      >
        <Stack
          sx={{
            display: "flex",
            flexDirection: "row",
            width: { xl: "85%", lg: "100%", md: "100%", sm: "100%" },
            height: { xl: "50vh", lg: "50vh", md: "52vh", sm: "52vh" },
            justifyContent: "space-between",
            gap: 2,
            // border: "1px solid blue",
          }}
        >
          <Stack
            sx={{
              width: { xl: "98%", lg: "75%", md: "72%", sm: "76%" },
              marginLeft: { xl: "12px", lg: "12px", md: "12px", sm: "0px" },
              height: "100%", // Ensures the stack takes full height
              display: "flex", // Enables flexbox
              flexDirection: "column", // Arranges children vertically
              // border: "2px solid blue",
            }}
          >
            {pmData === 0 && (
              <FrameSection1
                currentIndex={currentIndex}
                setCurrentIndex={setCurrentIndex}
              />
            )}

            {pmData === 1 && (
              <FrameSection1B
                currentIndex={currentIndex}
                setCurrentIndex={setCurrentIndex}
              />
            )}

            {pmData === 2 && (
              <FrameSection1C
                currentIndex={currentIndex}
                setCurrentIndex={setCurrentIndex}
              />
            )}
          </Stack>
          <Stack
            sx={{
              width: { xl: "28%", lg: "18%", md: "20%", sm: "20%" },
              marginRight: { xl: "60px", lg: "96px", md: "44px", sm: "44px" },
              // border: "2px solid green",
            }}
          >
            <FrameSection2
              activeIndex={currentIndex}
              setActiveIndex={setCurrentIndex}
              setPmData={setPmData}
              pmData={pmData}
            />
          </Stack>
        </Stack>
      </Stack>

      <BottomSection1 />
    </Stack>
  );
};

export default Testing1;
